const descriptionToStatusTextLookup = Object.freeze({
    'All Systems Operational': 'Operational',
    operational: 'Operational',
    'Partial System Outage': 'Partial Outage',
    partial_outage: 'Partial Outage',
    'Major Service Outage': 'Major Outage',
    major_outage: 'Major Outage',
    'Partially Degraded Service': 'Degraded Performance',
    degraded_performance: 'Degraded Performance',
    Maintenance: 'Maintenance',
    under_maintenance: 'Maintenance',
    Loading: 'Loading',
});

export default descriptionToStatusTextLookup;
